export type PrintTypeShort = 'S' | 'M' | 'L';
export type PrintTypeLong = 'SHORT' | 'MIDDLE' | 'LONG';

export class PrintType {
    static toLong(printType: PrintTypeShort): PrintTypeLong {
        switch (printType) {
            case 'S':
                return 'SHORT';
            case 'M':
                return 'MIDDLE';
            case 'L':
                return 'LONG';
            default:
                return <PrintTypeLong>printType;
        }
    }

    static toShort(printType: string): PrintTypeShort {
        switch (printType) {
            case 'SHORT':
                return 'S';
            case 'MIDDLE':
                return 'M';
            case 'LONG':
                return 'L';
            default:
                return <PrintTypeShort>printType;
        }
    }
}
